module.exports = __webpack_public_path__ + "static/img/guoquan.1703197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/guoquan.jpg
// module id = m04r
// module chunks = 1